// extracted by mini-css-extract-plugin
var _1 = "actual__E8hOW";
var _2 = "backgroundDecor__Nj7Ig";
var _3 = "backgroundImage__GzTkL";
var _4 = "bottom__kmPqu";
var _5 = "bullet__urEGn";
var _6 = "calculator__Nn1yh";
var _7 = "content__cUFuS";
var _8 = "decorImage___IVHT";
var _9 = "footnote__e292P";
var _a = "imageWrapper__Y0A8E";
var _b = "section__MV7WU";
var _c = "text__iPqnQ";
var _d = "title__hYLSD";
var _e = "top__OioyY";
export { _1 as "actual", _2 as "backgroundDecor", _3 as "backgroundImage", _4 as "bottom", _5 as "bullet", _6 as "calculator", _7 as "content", _8 as "decorImage", _9 as "footnote", _a as "imageWrapper", _b as "section", _c as "text", _d as "title", _e as "top" }
export default { "actual": _1, "backgroundDecor": _2, "backgroundImage": _3, "bottom": _4, "bullet": _5, "calculator": _6, "content": _7, "decorImage": _8, "footnote": _9, "imageWrapper": _a, "section": _b, "text": _c, "title": _d, "top": _e }
